import { bl_fi_frame_file_default_link_RowClass } from "../../../dbschema/bl_fi_frame_file_default_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class FrameFileDefaultLinkContainerModel extends BaseContainerModel {
  bl_fi_frame_file_default_link: bl_fi_frame_file_default_link_RowClass = new bl_fi_frame_file_default_link_RowClass();
}